import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import SvgIcon from '../../SvgIcon';

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M11.417 9.95A2.412 2.412 0 0 1 9 12.353a2.412 2.412 0 0 1-2.416-2.401A2.412 2.412 0 0 1 9 7.549a2.412 2.412 0 0 1 2.417 2.402M9 1C4.038 1 0 5.015 0 9.95c0 4.936 4.038 8.952 9 8.952a9.004 9.004 0 0 0 5.091-1.572l.215-.14-1.35-1.56-.147-.134-.163.104A6.755 6.755 0 0 1 9 16.665c-3.724 0-6.753-3.012-6.753-6.714 0-3.702 3.03-6.714 6.753-6.714 3.723 0 6.753 3.012 6.753 6.714 0 .48-.053.966-.158 1.437-.186.765-.674 1.005-1.096.97-.402-.032-.833-.307-.836-.984V9.95c0-2.557-2.092-4.639-4.663-4.639-2.57 0-4.663 2.082-4.663 4.639 0 2.557 2.092 4.638 4.663 4.638 1.16 0 2.255-.42 3.112-1.188a3.078 3.078 0 0 0 2.208 1.187 3.211 3.211 0 0 0 2.17-.632c.564-.426.984-1.039 1.214-1.774.001-.003.109-.372.105-.393A7.85 7.85 0 0 0 18 9.951C18 5.015 13.964 1 9 1"
});

export default function MailruIcon(props) {
  return React.createElement(SvgIcon, _extends({
    viewBox: "0 0 18 20"
  }, props), _ref);
}
MailruIcon.displayName = 'MailruIcon';
MailruIcon.defaultProps = {
  color: '#FFAF00'
};